export default "__VITE_ASSET__76617bfc__"